<div class="single-scene view-control-buttons">
    <div>
        <div id="pano" [ngClass]="isEditing ? 'edit' : ''"></div>

        <div class="d-flex justify-content-center back-overlay px-0 py-0">
            <agm-map
                class="h-100 rounded map d-none d-lg-block"
                [disableDoubleClickZoom]="true"
                [disableDefaultUI]="true"
                [zoomControl]="false"
                [latitude]="avgLat"
                [longitude]="avgLong"
                [zoom]="zoom"
                [mapTypeId]="'hybrid'"
                (mapReady)="initDrawManager($event)"
                [styles]="mapStyle"
            >
            </agm-map>
        </div>
        <div id="" class="actions-overlay position-absolute p-3">
            <div class="d-flex justify-content-center back-overlay px-3 py-2" *ngIf="isBack">
                <button
                    *ngFor="let item of backButtons; let i = index"
                    [attr.data-index]="i"
                    class="btn btn-backoffice"
                    [disabled]="item.disabled"
                    (click)="onBackButtonClick(item.tag)"
                    [ngClass]="{
                        'mr-3': i !== backButtons.length - 1,
                        'fake-disable': this.isEditing && this.currentAction !== item.tag
                    }"
                    [ngStyle]="{
                        background: item.background,
                        'box-shadow': this.isEditing && this.currentAction === item.tag ? 'none' : null
                    }"
                >
                    <img [src]="item.image" class="btn-backoffice-img pb-1" />
                    <div class="btn-backoffice-span">
                        <span>{{ item.text | translate }}</span>
                    </div>
                </button>
            </div>
        </div>
    </div>

    <!-- RIGHT PRODUCT MARKER EDIT MENU -->
    <div
        id="marker-edit-overlay"
        class="marker-edit-overlay position-absolute justify-content-center p-2"
        *ngIf="isBack && isEditingMarker"
    >
        <div class="d-flex justify-content-between align-items-center">
            <span class="marker-title">{{ this.currentMarkerName }}</span>
            <button class="marker-delete" (click)="onMarkerDelete()">
                <img src="assets/img/trash.png" class="delete-img" />
            </button>
        </div>
        <form class="w-100 mt-3">
            <ng-multiselect-dropdown
                [placeholder]="'PHOTOSPHERE_COMPONENT_MARKER_EDIT_PLACEHOLDER' | translate"
                [data]="products"
                [(ngModel)]="markerSelectedProduct"
                [settings]="dropdownSettings"
                (onSelect)="onProductSelect($event)"
                (onDeSelect)="onProductSelect($event)"
                name="product-id"
                class="w-100 px-2 rounded-1"
            >
            </ng-multiselect-dropdown>
        </form>
        <form class="w-100 mt-3" *ngIf="selectedProductMeasures">
            <span class="marker-title">{{ "PRODUCT_DETAIL_MEASURES_PLACEHOLDER" | translate }}</span>
            <ng-multiselect-dropdown
                [placeholder]="'PRODUCT_DETAIL_MEASURES_PLACEHOLDER' | translate"
                [data]="selectedProductMeasures"
                [(ngModel)]="selectedProductMeasure"
                [settings]="productMeasuresDropdownSettings"
                name="product-measure-id"
                class="w-100 px-2 rounded-1"
            >
            </ng-multiselect-dropdown>
        </form>
        <div class="d-flex justify-content-center mt-3">
            <button
                class="btn w-75 green-btn"
                [disabled]="!markerSelectedProduct || markerSelectedProduct.length === 0"
                (click)="onMarkerSave()"
            >
                {{ "PHOTOSPHERE_COMPONENT_MARKER_EDIT_SAVE" | translate }}
            </button>
        </div>
    </div>

    <!-- RIGHT PROMOTION MARKER EDIT MENU -->
    <div
        id="marker-edit-overlay"
        class="marker-edit-overlay position-absolute justify-content-center p-2"
        *ngIf="isBack && isEditingPromoMarker && !isNewPromo"
    >
        <div class="d-flex justify-content-between align-items-center">
            <span class="marker-title">{{ this.currentMarkerName }}</span>
            <button class="marker-delete" (click)="onMarkerDelete()">
                <img src="assets/img/trash.png" class="delete-img" />
            </button>
        </div>
        <form class="w-100 mt-3">
            <ng-multiselect-dropdown
                [placeholder]="'PHOTOSPHERE_COMPONENT_MARKER_EDIT_PLACEHOLDER' | translate"
                [data]="promotions"
                [(ngModel)]="markerSelectedPromotion"
                [settings]="promoDropdownSettings"
                name="promotion-id"
                class="w-100 px-2 rounded-1"
            >
            </ng-multiselect-dropdown>
        </form>
        <div class="d-flex justify-content-center mt-3">
            <button
                class="btn w-75 green-btn"
                [disabled]="markerSelectedPromotion == null || markerSelectedPromotion.length == 0"
                (click)="onMarkerSave()"
            >
                {{ "PHOTOSPHERE_COMPONENT_MARKER_EDIT_SAVE" | translate }}
            </button>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <button class="btn w-75" (click)="onNewPromotion()">
                {{ "HEADER_COMPONENT_LABEL_NEW" | translate }}
            </button>
        </div>
    </div>

    <!--
    <promotion-list
        [promotions]="this.promotions"
        [isEditing]="isBack && isEditing && currentAction === 'promo'"
        (clickEvent)="onPromoClick($event)"
        (newClick)="onPromoNew()"
        class="position-absolute pb-2 pr-3"
        *ngIf="!(isBack && (isEditingMarker || isEditingPromo || isEditingArrow || isEditingShortcuts))"
    >
    </promotion-list>
    -->

    <promotion-editor
        [editedPromo]="this.editedPromo"
        [products]="this.products"
        [nurseryUuid]="this.nurseryUUID"
        (promoDelete)="onMarkerDelete()"
        (promoSave)="onPromoSave($event)"
        id="promo-edit-overlay"
        class="position-absolute justify-content-center"
        *ngIf="isBack && isNewPromo"
    >
    </promotion-editor>

    <arrow-editor
        (arrowSave)="onArrowSave($event)"
        (closeSection)="handleArrowsSection()"
        [editedMarkerUUID]="this.editedArrowUUID"
        id="arrow-edit-overlay"
        class="position-absolute justify-content-center"
        *ngIf="isBack && isEditingArrow"
    >
    </arrow-editor>

    <shortcut-list
        *ngIf="isBack && isEditingShortcuts"
        [nurseryUUID]="this.nurseryUUID"
        [photosphereUUID]="this.shortcutPhotosphere"
        [editEnabled]="true"
        (sphereChosen)="onShowShortcut($event)"
        (closeSection)="handleShortcutsSection()"
        id="shortcut-list-overlay"
        class="position-absolute justify-content-center"
    >
    </shortcut-list>

    <product-link
        [sphereUUID]="this.sphereUUID"
        [editedProductLink]="this.editedProductLink"
        [products]="this.products"
        (productLinkClose)="onProductLinkClose()"
        (productLinkDelete)="onProductLinkDelete()"
        (productLinkSave)="onProductLinkSave($event)"
        id="product-link-overlay"
        class="position-absolute justify-content-center"
        *ngIf="isBack && isEditingProductLink"
    >
    </product-link>

    <img
        *ngIf="this.isEditing && this.currentAction === 'correct'"
        class="direction-arrow position-absolute"
        src="assets/img/ic_photosphere.png"
        (click)="onCorrectYawClick()"
    />

    <div id="title-bar" hidden>
        <h1 class="scene-name"></h1>
    </div>

    <a href="javascript:void(0)" id="fullscreen-toggle">
        <img class="icon off" src="assets/js/marzipano/img/fullscreen.png" />
        <img class="icon on" src="assets/js/marzipano/img/windowed.png" />
    </a>
</div>
